export * from './queries';

export const storeKeys = {
  allStores: (locale: string) => ['ALL STORES', locale],
  AllPointsOfSale: (locale: string, deliverymethod: number) => ['ALL POINTS OF SALE', locale, deliverymethod],
  accountStore: (id: string) => ['ACCOUNT STORE', id],
};
